<template lang="pug">
.log-wrapper
  .logbox
    b-card.shadow-lg.rounded.theme-glass
      div.p-4
        div.d-flex.flex-row.align-items-baseline
          h4 {{ $t("ui.domain_member_setup") }}
        b-form.form-signin(@submit.stop.prevent="submit" novalidate :disabled="!submission.success")
          b-input-group(size="lg")
            b-input-group-text(slot="prepend")
              i.fas.fa-solid.fa-link
            DomainAvailableList(
              ref="domain_name"
              size="lg"
              required
              type="array"
              :dirty="$v.domain_name.$dirty"
              :error="$v.domain_name.$error"
              v-model.trim.lazy="$v.domain_name.$model"
              :disabled="loading"
            )
          ValidateResult(:value="$v.domain_name" :name="$t('ui.domain_name')")
          div.row.pt-2
            div.col
              b-alert.text-center.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
          div.row
            .m-auto.w-70
              SubmitButton.btn-block.noboxshadow.br-8(icon="fa fa-sign-in-alt" :text="$t('ui.submit')" variant="warning" size="xs" :loading="loading" isModal=false)
</template>

<script>
import config from "@/config";
import { required, minLength, maxLength, alphaNum } from "vuelidate/lib/validators";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DomainAvailableList from "@/library/DomainAvailableList";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DomainAvailableList
  },
  data: function() {
    return {
      domain_name: "",
      loading: false,
      submission: {
        success: true,
        status: ""
      }
    };
  },
  validations: {
    domain_name: {
      required
    }
  },
  computed: {
  },
  mounted: function() {
  },
  methods: {
    reset: function() {
      this.$v.$reset();
      this.submission.success = true;
      this.submission.status = "";
      this.$refs.domain_name.$el.focus();
    },
    submit: function() {
      this.reset();
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let domain_name = this.domain_name;
        this.loading = true;
        this.$store
          .dispatch("user/domainMemberSetup", { domain_name })
          .then(response => {
            this.loading = false;
            this.submission.success = response.success;
            this.submission.status = response.status;
            if (this.submission.success == true) {
              this.$router.push("/memberList");
            }
          })
          .catch(response => {
            this.loading = false;
            this.submission.success = response.success;
            this.submission.status = this.$t("error." + response.status);
          });
      }
    }
  }
};
</script>

